import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, Input, OnDestroy, OnInit } from "@angular/core";

import { WebhookFormInputComponent } from "../webhook-form-input/webhook-form-input.component";
import { WebhookCommonComponent } from "../common.components";
import { BehaviorSubject, Subscription } from "rxjs";
import { HTTPService } from "src/app/services/http.service";
import { Variable } from "src/app/forms/formula-tester/formula-tester.component";
import { GlobalErrorHandler } from "src/app/services/GloabalErrorHandler.services";

@Component({
    selector: 'webhook-form-query-select',
    templateUrl: './webhook-form-query-select.component.html',
    styleUrl: './webhook-form-query-select.component.scss',
    standalone: false
})

export class WebhookFormQuerySelectComponent extends WebhookCommonComponent implements OnInit, OnDestroy {
   
    ob1:Subscription;
    dynamicList:BehaviorSubject<Object[]> = new BehaviorSubject<Object[]>([]);
    http:HTTPService = inject(HTTPService);
    
  override ngOnInit(): void {
      super.ngOnInit();
      this.commomServices.getDataNativeQuery(this.field.condition, this.variables).then(data=>{
          if ( data){
            this.dynamicList.next(data as Object[]);
          }
      }).catch(error=>{
        //   let message = GlobalErrorHandler.getMessage(error)
        //   this.commomServices.showErrorSimple(message);
        GlobalErrorHandler.showError(error);
      });
  }
   
  
}